export default {
  title: 'Find Scientific Illustrations, Icons, Images, and Drawings',
  subTitle:
    "From the world's largest gallery of accurate scientific illustrations, icons, images and pictures!",
  label: 'Search among our 75,000+ illustrations',
};
